import {REPORT_SET_STATE, REPORT_SET_SUBREPORT_CURRENT_PAGE, REPORT_SET_SUBREPORT_PAGES} from './types';

export const mutations = {
  [REPORT_SET_STATE]: (state, payload) => {
    state.report.id = payload.id;
    state.report.title = payload.title;
    state.report.subtitle = payload.subtitle;
    state.report.reports = payload.reports;
    state.report.logo = payload.logo;
  },

  [REPORT_SET_SUBREPORT_CURRENT_PAGE]: (state, payload) => {
    state.report.subReportCurrentPage = payload;
  },

  [REPORT_SET_SUBREPORT_PAGES]: (state, payload) => {
    state.report.subReportPages = payload;
  }
};
